// Function to close mobile menu
window.closeMobileMenu = function () {
  const menuToggle = document.getElementById("left-menu");
  if (menuToggle) {
    menuToggle.checked = false;
    document.body.classList.remove("menu-open");
    document.body.style.overflow = "";
  }
};

function openMenuItem(evt, tabName) {
  // Hide all tab content
  const tabContents = document.getElementsByClassName("tabcontent");
  for (let i = 0; i < tabContents.length; i++) {
    tabContents[i].classList.remove("active");
  }

  // Remove active class from all tab buttons
  const tabButtons = document.getElementsByClassName("tablinks");
  for (let i = 0; i < tabButtons.length; i++) {
    tabButtons[i].classList.remove("active");
  }

  // Show the current tab and add active class to the button
  document.getElementById(tabName).classList.add("active");
  evt.currentTarget.classList.add("active");
}

// Initialize the menu
document.addEventListener("DOMContentLoaded", function () {
  // Set default tab
  const defaultTab = document.getElementById("defaultOpen");
  if (defaultTab) {
    defaultTab.click();
  }

  // Handle menu drawer toggle
  const menuToggle = document.getElementById("left-menu");
  const menuDrawer = document.querySelector(".left-navigation");
  const menuCloses = document.querySelectorAll(".mobile-menu-close");

  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener("change", function () {
      if (this.checked) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    });

    menuCloses.forEach((menuClose) => {
      menuClose.addEventListener("click", function () {
        closeMobileMenu();
      });
    });
  }

  // Handle submenu toggles
  const submenuToggles = document.querySelectorAll(
    '.handle-menu input[type="checkbox"]'
  );
  submenuToggles.forEach((toggle) => {
    toggle.addEventListener("change", function () {
      const nav = this.nextElementSibling;
      if (nav) {
        if (this.checked) {
          nav.style.display = "block";
        } else {
          nav.style.display = "none";
        }
      }
    });
  });

  // Handle collection links
  const collectionLinks = document.querySelectorAll('a[href*="/collections/"]');
  collectionLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const href = this.getAttribute("href");
      if (href && href !== "#") {
        // Close the menu before navigation
        if (menuToggle) {
          menuToggle.checked = false;
          document.body.style.overflow = "";
        }
        // Add a small delay before navigation
        setTimeout(() => {
          window.location.href = href;
        }, 100);
      }
    });
  });
});
